import React, {Fragment} from 'react';
import {PageMetaTags} from '@common/http/page-meta-tags';
import {PageStatus} from '@common/http/page-status';
import {TitlePageHeaderImage} from '@app/titles/pages/title-page/title-page-header-image';
import {TitlePageHeader} from '@app/titles/pages/title-page/title-page-header';
import {SitePageLayout} from '@app/site-page-layout';
import {GetTitleResponse, useTitle} from '@app/titles/requests/use-title';
import {SiteSectionHeading} from '@app/titles/site-section-heading';
import {Trans} from '@common/i18n/trans';
import {TitleCreditsGrid} from '@app/titles/pages/title-page/title-credits-grid/title-credits-grid';
import {ArrowUp2} from 'iconsax-react';

export function TitleFullCreditsPage() {
  const query = useTitle('titleCreditsPage');

  const content = query.data ? (
    <Fragment>
      <PageMetaTags query={query} />
      <PageContent data={query.data} />
    </Fragment>
  ) : (
    <PageStatus query={query} loaderClassName="absolute inset-0 m-auto" />
  );

  return <SitePageLayout>{content}</SitePageLayout>;
}

interface PageContentProps {
  data: GetTitleResponse;
}
function PageContent({
  data: {title, credits: groupedCredits = {}},
}: PageContentProps) {
  //Directors
  //Writers
  //Cast

  const artistOrder = {
    Directors: 1,
    Writers: 2,
    Cast: 3,
  };
  console.log(groupedCredits);

  return (
    <div>
      <TitlePageHeaderImage title={title} />
      <div
        className="fixed bottom-10 right-20 z-50 cursor-pointer rounded-lg bg-[#AA4A44]"
        onClick={() => window.scrollTo(0, 0)}
      >
        <ArrowUp2 size={40} className="text-white" />
      </div>
      <div className="container mx-auto mt-24 px-14 md:mt-40 md:px-24">
        {/* <TitlePageHeader title={title} showPoster /> */}
        <div className="mt-48 @container">
          <SiteSectionHeading headingType="h2" className="mb-40">
            <Trans message="Full Credits" />
          </SiteSectionHeading>
          {Object.entries(groupedCredits)
            .sort(([departmentA], [departmentB]) => {
              // Put "actors" first, then sort the rest alphabetically
              const creditPriorityA =
                artistOrder[departmentA as keyof typeof artistOrder] ||
                Infinity;
              const creditPriorityB =
                artistOrder[departmentB as keyof typeof artistOrder] ||
                Infinity;
              // if (departmentA === 'actors') return -1;
              // if (departmentB === 'actors') return 1;
              // return departmentA.localeCompare(departmentB);
              return creditPriorityA - creditPriorityB;
            })
            .map(([department, credits]) => (
              <div key={department}>
                <h3 className="mb-16 text-2xl font-bold capitalize">
                  <Trans
                    message={
                      credits.length > 1
                        ? department
                        : department === 'Directors'
                          ? 'Director'
                          : department === 'Writers'
                            ? 'Writer'
                            : department === 'Editors'
                              ? 'Editor'
                              : department === 'Producers'
                                ? 'Producer'
                                : department === 'Stunts'
                                  ? 'Stunt'
                                  : department === 'Cinematographers'
                                    ? 'Cinematographer'
                                    : department === 'Composers'
                                      ? 'Composer'
                                      : department === 'Cast'
                                        ? 'actor'
                                        : department
                    }
                  />
                </h3>
                <TitleCreditsGrid credits={credits} className="mb-68" />
              </div>
            ))}
          {/* {Object.entries(groupedCredits).map(([department, credits]) => (
            <div key={department}>
              <h3 className="mb-16 text-2xl font-bold capitalize">
                <Trans message={department} />
              </h3>
              <TitleCreditsGrid credits={credits} className="mb-68" />
            </div>
          ))} */}
        </div>
      </div>
    </div>
  );
}
